export default {
  title: 'Klaar ermee?',
  text: 'Als je dit familielid verwijdert, dan moet je deze Avatar helemaal opnieuw maken!',
  confirm: 'Verwijder',
  cancel: 'Terug'
};
